/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BookingPriceBandOutput,
    BookingPriceBandOutputFromJSON,
    BookingPriceBandOutputFromJSONTyped,
    BookingPriceBandOutputToJSON,
    CabinClassTypeCriteriaOutput,
    CabinClassTypeCriteriaOutputFromJSON,
    CabinClassTypeCriteriaOutputFromJSONTyped,
    CabinClassTypeCriteriaOutputToJSON,
    CharCriteriaOutput,
    CharCriteriaOutputFromJSON,
    CharCriteriaOutputFromJSONTyped,
    CharCriteriaOutputToJSON,
    CriteriaForBookingDateTimeOutput,
    CriteriaForBookingDateTimeOutputFromJSON,
    CriteriaForBookingDateTimeOutputFromJSONTyped,
    CriteriaForBookingDateTimeOutputToJSON,
    CriteriaForLocationOutput,
    CriteriaForLocationOutputFromJSON,
    CriteriaForLocationOutputFromJSONTyped,
    CriteriaForLocationOutputToJSON,
    CriteriaForRouteOutput,
    CriteriaForRouteOutputFromJSON,
    CriteriaForRouteOutputFromJSONTyped,
    CriteriaForRouteOutputToJSON,
    DateTimeCriteriaRangeOutput,
    DateTimeCriteriaRangeOutputFromJSON,
    DateTimeCriteriaRangeOutputFromJSONTyped,
    DateTimeCriteriaRangeOutputToJSON,
    FareTypeCriteriaOutput,
    FareTypeCriteriaOutputFromJSON,
    FareTypeCriteriaOutputFromJSONTyped,
    FareTypeCriteriaOutputToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
    Int32CriteriaRangeOutput,
    Int32CriteriaRangeOutputFromJSON,
    Int32CriteriaRangeOutputFromJSONTyped,
    Int32CriteriaRangeOutputToJSON,
    JourneyTypeCriteriaOutput,
    JourneyTypeCriteriaOutputFromJSON,
    JourneyTypeCriteriaOutputFromJSONTyped,
    JourneyTypeCriteriaOutputToJSON,
    PriorityType,
    PriorityTypeFromJSON,
    PriorityTypeFromJSONTyped,
    PriorityTypeToJSON,
    StringCriteriaForMarketingAirlineOutput,
    StringCriteriaForMarketingAirlineOutputFromJSON,
    StringCriteriaForMarketingAirlineOutputFromJSONTyped,
    StringCriteriaForMarketingAirlineOutputToJSON,
    StringCriteriaOutput,
    StringCriteriaOutputFromJSON,
    StringCriteriaOutputFromJSONTyped,
    StringCriteriaOutputToJSON,
    StringCriteriaRangeOutput,
    StringCriteriaRangeOutputFromJSON,
    StringCriteriaRangeOutputFromJSONTyped,
    StringCriteriaRangeOutputToJSON,
    SystemContextOutput,
    SystemContextOutputFromJSON,
    SystemContextOutputFromJSONTyped,
    SystemContextOutputToJSON,
} from './';

/**
 * 
 * @export
 * @interface MarkupOutput
 */
export interface MarkupOutput {
    /**
     * 
     * @type {Array<StringCriteriaOutput>}
     * @memberof MarkupOutput
     */
    accountCodes?: Array<StringCriteriaOutput> | null;
    /**
     * 
     * @type {Array<CharCriteriaOutput>}
     * @memberof MarkupOutput
     */
    bookingClasses?: Array<CharCriteriaOutput> | null;
    /**
     * 
     * @type {Array<CriteriaForBookingDateTimeOutput>}
     * @memberof MarkupOutput
     */
    bookingDateTimes?: Array<CriteriaForBookingDateTimeOutput> | null;
    /**
     * 
     * @type {Array<BookingPriceBandOutput>}
     * @memberof MarkupOutput
     */
    bookingPriceBands?: Array<BookingPriceBandOutput> | null;
    /**
     * 
     * @type {Array<CabinClassTypeCriteriaOutput>}
     * @memberof MarkupOutput
     */
    cabinClasses?: Array<CabinClassTypeCriteriaOutput> | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupOutput
     */
    comment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupOutput
     */
    description?: string | null;
    /**
     * 
     * @type {Array<StringCriteriaOutput>}
     * @memberof MarkupOutput
     */
    fareBasisCodes?: Array<StringCriteriaOutput> | null;
    /**
     * 
     * @type {Array<FareTypeCriteriaOutput>}
     * @memberof MarkupOutput
     */
    fareTypes?: Array<FareTypeCriteriaOutput> | null;
    /**
     * 
     * @type {Array<StringCriteriaRangeOutput>}
     * @memberof MarkupOutput
     */
    flightNumbers?: Array<StringCriteriaRangeOutput> | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupOutput
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupOutput
     */
    includeTax?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupOutput
     */
    isDeleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupOutput
     */
    isEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupOutput
     */
    isExclusionRule?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MarkupOutput
     */
    allowEdit?: boolean;
    /**
     * 
     * @type {Array<JourneyTypeCriteriaOutput>}
     * @memberof MarkupOutput
     */
    journeyTypes?: Array<JourneyTypeCriteriaOutput> | null;
    /**
     * 
     * @type {Array<CriteriaForLocationOutput>}
     * @memberof MarkupOutput
     */
    locations?: Array<CriteriaForLocationOutput> | null;
    /**
     * 
     * @type {Array<StringCriteriaForMarketingAirlineOutput>}
     * @memberof MarkupOutput
     */
    marketingAirlines?: Array<StringCriteriaForMarketingAirlineOutput> | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupOutput
     */
    markupAmount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarkupOutput
     */
    markupPercentage?: number | null;
    /**
     * 
     * @type {Array<Int32CriteriaRangeOutput>}
     * @memberof MarkupOutput
     */
    passengerAges?: Array<Int32CriteriaRangeOutput> | null;
    /**
     * 
     * @type {PriorityType}
     * @memberof MarkupOutput
     */
    priority?: PriorityType;
    /**
     * 
     * @type {number}
     * @memberof MarkupOutput
     */
    readonly priorityAsInt?: number | null;
    /**
     * 
     * @type {Array<CriteriaForRouteOutput>}
     * @memberof MarkupOutput
     */
    routes?: Array<CriteriaForRouteOutput> | null;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof MarkupOutput
     */
    suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {SystemContextOutput}
     * @memberof MarkupOutput
     */
    systemContext?: SystemContextOutput;
    /**
     * 
     * @type {Array<StringCriteriaOutput>}
     * @memberof MarkupOutput
     */
    ticketDesignators?: Array<StringCriteriaOutput> | null;
    /**
     * 
     * @type {Array<DateTimeCriteriaRangeOutput>}
     * @memberof MarkupOutput
     */
    travelDateTimes?: Array<DateTimeCriteriaRangeOutput> | null;
    /**
     * 
     * @type {string}
     * @memberof MarkupOutput
     */
    version?: string | null;
}

export function MarkupOutputFromJSON(json: any): MarkupOutput {
    return MarkupOutputFromJSONTyped(json, false);
}

export function MarkupOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarkupOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'accountCodes': !exists(json, 'accountCodes') ? undefined : (json['accountCodes'] === null ? null : (json['accountCodes'] as Array<any>).map(StringCriteriaOutputFromJSON)),
        'bookingClasses': !exists(json, 'bookingClasses') ? undefined : (json['bookingClasses'] === null ? null : (json['bookingClasses'] as Array<any>).map(CharCriteriaOutputFromJSON)),
        'bookingDateTimes': !exists(json, 'bookingDateTimes') ? undefined : (json['bookingDateTimes'] === null ? null : (json['bookingDateTimes'] as Array<any>).map(CriteriaForBookingDateTimeOutputFromJSON)),
        'bookingPriceBands': !exists(json, 'bookingPriceBands') ? undefined : (json['bookingPriceBands'] === null ? null : (json['bookingPriceBands'] as Array<any>).map(BookingPriceBandOutputFromJSON)),
        'cabinClasses': !exists(json, 'cabinClasses') ? undefined : (json['cabinClasses'] === null ? null : (json['cabinClasses'] as Array<any>).map(CabinClassTypeCriteriaOutputFromJSON)),
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'fareBasisCodes': !exists(json, 'fareBasisCodes') ? undefined : (json['fareBasisCodes'] === null ? null : (json['fareBasisCodes'] as Array<any>).map(StringCriteriaOutputFromJSON)),
        'fareTypes': !exists(json, 'fareTypes') ? undefined : (json['fareTypes'] === null ? null : (json['fareTypes'] as Array<any>).map(FareTypeCriteriaOutputFromJSON)),
        'flightNumbers': !exists(json, 'flightNumbers') ? undefined : (json['flightNumbers'] === null ? null : (json['flightNumbers'] as Array<any>).map(StringCriteriaRangeOutputFromJSON)),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'includeTax': !exists(json, 'includeTax') ? undefined : json['includeTax'],
        'isDeleted': !exists(json, 'isDeleted') ? undefined : json['isDeleted'],
        'isEnabled': !exists(json, 'isEnabled') ? undefined : json['isEnabled'],
        'isExclusionRule': !exists(json, 'isExclusionRule') ? undefined : json['isExclusionRule'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
        'journeyTypes': !exists(json, 'journeyTypes') ? undefined : (json['journeyTypes'] === null ? null : (json['journeyTypes'] as Array<any>).map(JourneyTypeCriteriaOutputFromJSON)),
        'locations': !exists(json, 'locations') ? undefined : (json['locations'] === null ? null : (json['locations'] as Array<any>).map(CriteriaForLocationOutputFromJSON)),
        'marketingAirlines': !exists(json, 'marketingAirlines') ? undefined : (json['marketingAirlines'] === null ? null : (json['marketingAirlines'] as Array<any>).map(StringCriteriaForMarketingAirlineOutputFromJSON)),
        'markupAmount': !exists(json, 'markupAmount') ? undefined : json['markupAmount'],
        'markupPercentage': !exists(json, 'markupPercentage') ? undefined : json['markupPercentage'],
        'passengerAges': !exists(json, 'passengerAges') ? undefined : (json['passengerAges'] === null ? null : (json['passengerAges'] as Array<any>).map(Int32CriteriaRangeOutputFromJSON)),
        'priority': !exists(json, 'priority') ? undefined : PriorityTypeFromJSON(json['priority']),
        'priorityAsInt': !exists(json, 'priorityAsInt') ? undefined : json['priorityAsInt'],
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(CriteriaForRouteOutputFromJSON)),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'systemContext': !exists(json, 'systemContext') ? undefined : SystemContextOutputFromJSON(json['systemContext']),
        'ticketDesignators': !exists(json, 'ticketDesignators') ? undefined : (json['ticketDesignators'] === null ? null : (json['ticketDesignators'] as Array<any>).map(StringCriteriaOutputFromJSON)),
        'travelDateTimes': !exists(json, 'travelDateTimes') ? undefined : (json['travelDateTimes'] === null ? null : (json['travelDateTimes'] as Array<any>).map(DateTimeCriteriaRangeOutputFromJSON)),
        'version': !exists(json, 'version') ? undefined : json['version'],
    };
}

export function MarkupOutputToJSON(value?: MarkupOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'accountCodes': value.accountCodes === undefined ? undefined : (value.accountCodes === null ? null : (value.accountCodes as Array<any>).map(StringCriteriaOutputToJSON)),
        'bookingClasses': value.bookingClasses === undefined ? undefined : (value.bookingClasses === null ? null : (value.bookingClasses as Array<any>).map(CharCriteriaOutputToJSON)),
        'bookingDateTimes': value.bookingDateTimes === undefined ? undefined : (value.bookingDateTimes === null ? null : (value.bookingDateTimes as Array<any>).map(CriteriaForBookingDateTimeOutputToJSON)),
        'bookingPriceBands': value.bookingPriceBands === undefined ? undefined : (value.bookingPriceBands === null ? null : (value.bookingPriceBands as Array<any>).map(BookingPriceBandOutputToJSON)),
        'cabinClasses': value.cabinClasses === undefined ? undefined : (value.cabinClasses === null ? null : (value.cabinClasses as Array<any>).map(CabinClassTypeCriteriaOutputToJSON)),
        'comment': value.comment,
        'description': value.description,
        'fareBasisCodes': value.fareBasisCodes === undefined ? undefined : (value.fareBasisCodes === null ? null : (value.fareBasisCodes as Array<any>).map(StringCriteriaOutputToJSON)),
        'fareTypes': value.fareTypes === undefined ? undefined : (value.fareTypes === null ? null : (value.fareTypes as Array<any>).map(FareTypeCriteriaOutputToJSON)),
        'flightNumbers': value.flightNumbers === undefined ? undefined : (value.flightNumbers === null ? null : (value.flightNumbers as Array<any>).map(StringCriteriaRangeOutputToJSON)),
        'id': value.id,
        'includeTax': value.includeTax,
        'isDeleted': value.isDeleted,
        'isEnabled': value.isEnabled,
        'isExclusionRule': value.isExclusionRule,
        'allowEdit': value.allowEdit,
        'journeyTypes': value.journeyTypes === undefined ? undefined : (value.journeyTypes === null ? null : (value.journeyTypes as Array<any>).map(JourneyTypeCriteriaOutputToJSON)),
        'locations': value.locations === undefined ? undefined : (value.locations === null ? null : (value.locations as Array<any>).map(CriteriaForLocationOutputToJSON)),
        'marketingAirlines': value.marketingAirlines === undefined ? undefined : (value.marketingAirlines === null ? null : (value.marketingAirlines as Array<any>).map(StringCriteriaForMarketingAirlineOutputToJSON)),
        'markupAmount': value.markupAmount,
        'markupPercentage': value.markupPercentage,
        'passengerAges': value.passengerAges === undefined ? undefined : (value.passengerAges === null ? null : (value.passengerAges as Array<any>).map(Int32CriteriaRangeOutputToJSON)),
        'priority': PriorityTypeToJSON(value.priority),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(CriteriaForRouteOutputToJSON)),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
        'systemContext': SystemContextOutputToJSON(value.systemContext),
        'ticketDesignators': value.ticketDesignators === undefined ? undefined : (value.ticketDesignators === null ? null : (value.ticketDesignators as Array<any>).map(StringCriteriaOutputToJSON)),
        'travelDateTimes': value.travelDateTimes === undefined ? undefined : (value.travelDateTimes === null ? null : (value.travelDateTimes as Array<any>).map(DateTimeCriteriaRangeOutputToJSON)),
        'version': value.version,
    };
}


